<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Devoluções de Vendas</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Gerencie as definições padrão das devoluções de vendas.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="300" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="section-container">
          <div class="row mt-3">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="lancarEstoqueAutomatico">
                  Lançar estoque automático ao finalizar devolução
                </mat-slide-toggle>
                <span class="info-text">
                  Ao finalizar uma devolução manualmente ou ao autorizar a nota de devolução no Sefaz, o estoque
                  será lançado automaticamente.
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()">
</app-footer-action>
